import Core from '_abstracts/core'

Core.Tasks.add(['user'], () => {
    try {
        const cXenseIDs = {
            'gazetadopovo': '1138596144857280556',
            'semprefamilia': '1151002723869717418',
            'umdoisesportes': '1139722051567259179'
        }

        window.cX = window.cX || {};
        window.cX.callQueue = window.cX.callQueue || [];
        window.cX.options = cX.options || { compat: { c1x: { wait: 3000 }}};

        window.cX.CCE = cX.CCE || {};
        window.cX.CCE.callQueue = window.cX.CCE.callQueue || [];

        window.tp = window.tp || [];

        console.log("window.cX", window.cX)
        console.log("window.ID", cXenseIDs[Core.Config.get('domain')])

        const identityTypes = { 'gdp_user-state': 'unlogged' }

        if (Core.User.get('isLogged')) {
            identityTypes['gdp_user-state'] = Core.User.get('isSubscriber') ? 'subscriber' : 'registered'
            window.cX.callQueue.push(['addExternalId', { 'id': Core.User.get('id'), 'type': 'gdp'}])
        }

        window.tp.push(['setCxenseId', cXenseIDs[Core.Config.get('domain')]]);
        window.cX.callQueue.push(['setSiteId', cXenseIDs[Core.Config.get('domain')]]);
        window.cX.callQueue.push(['setCustomParameters', identityTypes]);
        window.cX.CCE.callQueue.push(['sendPageViewEvent']);
    } catch (ex) {
        console.error(ex)
    }
})

